// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Formality from "../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as GeoRegionHook from "../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FormInput$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ModalFooter$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalFooter.bs.js";
import * as BulkUploadRepoManager from "./app/bulk-upload/repo/BulkUploadRepoManager.bs.js";
import * as CsvFileParser$Catalyst from "../../../../node_modules/@porterin/catalyst/src/helper-modules/csv-parser/CsvFileParser.bs.js";
import * as Formality__ReactUpdate from "../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as CircularLoader$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as FormSelectInput$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as BulkUploadTransactionHelper from "./view/library/BulkUploadTransactionHelper.bs.js";
import * as BulkUploadTransactionsUseCase from "./library/BulkUploadTransactionsUseCase.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var validators_fileUploadResult = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var fileUploadResult = param.fileUploadResult;
      if (fileUploadResult === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Select File"
              };
      }
      var result = fileUploadResult[0];
      if (result.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: [
                  {
                    TAG: /* Ok */0,
                    _0: result._0
                  },
                  fileUploadResult[1]
                ]
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "CSV file error"
              };
      }
    })
};

var validators_reason = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var reason = param.reason;
      if (reason !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: reason
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Select Reason"
              };
      }
    })
};

var validators_city = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var city = param.city;
      if (city !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: city.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Select City"
              };
      }
    })
};

var validators = {
  fileUploadResult: validators_fileUploadResult,
  reason: validators_reason,
  city: validators_city
};

function initialFieldsStatuses(_input) {
  return {
          fileUploadResult: /* Pristine */0,
          reason: /* Pristine */0,
          city: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            fileUploadResult: /* Pristine */0,
            reason: /* Pristine */0,
            city: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.fileUploadResult;
  var match_0 = match ? match._0 : Curry._1(validators.fileUploadResult.validate, input);
  var match$1 = fieldsStatuses.reason;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.reason.validate, input);
  var match$2 = fieldsStatuses.city;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.city.validate, input);
  var fileUploadResultResult = match_0;
  var fileUploadResultResult$1;
  if (fileUploadResultResult.TAG === /* Ok */0) {
    var reasonResult = match_0$1;
    if (reasonResult.TAG === /* Ok */0) {
      var cityResult = match_0$2;
      if (cityResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  city: cityResult._0,
                  reason: reasonResult._0,
                  fileUploadResult: fileUploadResultResult._0
                },
                fieldsStatuses: {
                  fileUploadResult: /* Dirty */{
                    _0: fileUploadResultResult,
                    _1: /* Shown */0
                  },
                  reason: /* Dirty */{
                    _0: reasonResult,
                    _1: /* Shown */0
                  },
                  city: /* Dirty */{
                    _0: cityResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      fileUploadResultResult$1 = fileUploadResultResult;
    } else {
      fileUploadResultResult$1 = fileUploadResultResult;
    }
  } else {
    fileUploadResultResult$1 = fileUploadResultResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            fileUploadResult: /* Dirty */{
              _0: fileUploadResultResult$1,
              _1: /* Shown */0
            },
            reason: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            city: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurFileUploadResultField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.fileUploadResult, validators_fileUploadResult, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  fileUploadResult: status,
                                  reason: init.reason,
                                  city: init.city
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurReasonField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.reason, validators_reason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  fileUploadResult: init.fileUploadResult,
                                  reason: status,
                                  city: init.city
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCityField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  fileUploadResult: init.fileUploadResult,
                                  reason: init.reason,
                                  city: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */3,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */4,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */6);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */5);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateFileUploadResultField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.fileUploadResult, state.submissionStatus, validators_fileUploadResult, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            fileUploadResult: status,
                                            reason: init.reason,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateReasonField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.reason, state.submissionStatus, validators_reason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            fileUploadResult: init.fileUploadResult,
                                            reason: status,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCityField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            fileUploadResult: init.fileUploadResult,
                                            reason: init.reason,
                                            city: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                fileUploadResult: /* Pristine */0,
                                reason: /* Pristine */0,
                                city: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                fileUploadResult: /* Pristine */0,
                                reason: /* Pristine */0,
                                city: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateFileUploadResult: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFileUploadResultField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateReasonField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCityField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurFileUploadResult: (function (param) {
              return Curry._1(dispatch, /* BlurFileUploadResultField */0);
            }),
          blurReason: (function (param) {
              return Curry._1(dispatch, /* BlurReasonField */1);
            }),
          blurCity: (function (param) {
              return Curry._1(dispatch, /* BlurCityField */2);
            }),
          fileUploadResultResult: Formality.exposeFieldResult(state.fieldsStatuses.fileUploadResult),
          reasonResult: Formality.exposeFieldResult(state.fieldsStatuses.reason),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.fileUploadResult || match.reason || match.city) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */5,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */6);
            })
        };
}

var BulkUploadTransactionForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function BulkUploadTransactionsModalContent(Props) {
  var bulkUploadTransactions = Props.bulkUploadTransactions;
  var requestStatus = Props.requestStatus;
  var resetRequestStatus = Props.resetRequestStatus;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setBulkReasons = match[1];
  var bulkReasons = match[0];
  var match$1 = React.useState(function () {
        return /* [] */0;
      });
  var setReasonOptions = match$1[1];
  var reasonOptions = match$1[0];
  var match$2 = CountryContext.useContext(undefined);
  var country = match$2.country;
  var form = useForm({
        city: undefined,
        reason: undefined,
        fileUploadResult: undefined
      }, (function (output, submissionCbs) {
          return Curry._2(bulkUploadTransactions, {
                      city: output.city,
                      reason: output.reason,
                      fileUploadResult: output.fileUploadResult
                    }, (function (param) {
                        Curry._1(submissionCbs.notifyOnSuccess, undefined);
                        return Curry._1(submissionCbs.dismissSubmissionResult, undefined);
                      }));
        }));
  React.useEffect((function () {
          Curry._1(setBulkReasons, (function (param) {
                  return {
                          TAG: /* Loading */0,
                          _0: undefined
                        };
                }));
          var RepoInstance = BulkUploadRepoManager.getRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.fetchBulkReasons, country);
                }), (function (data) {
                  return Curry._1(setBulkReasons, (function (param) {
                                Curry._1(setReasonOptions, (function (param) {
                                        return Belt_List.mapWithIndex(Belt_List.keepWithIndex(Belt_List.concat(data.credit, data.debit), (function (e, param) {
                                                          return e.is_bulk_txn_allowed;
                                                        })), (function (i, e) {
                                                      return {
                                                              key: String(i),
                                                              value: e.reason_enum,
                                                              text: e.reason
                                                            };
                                                    }));
                                      }));
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setBulkReasons, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
          
        }), []);
  React.useEffect((function () {
          if (typeof requestStatus === "number") {
            
          } else {
            Curry._1(resetRequestStatus, undefined);
          }
          
        }), [form.input]);
  var georegions = GeoRegionHook.useGeoRegions(country);
  switch (georegions.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var cityOptions = BulkUploadTransactionHelper.getCityItems(georegions._0);
        var tmp;
        if (typeof bulkReasons === "number") {
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
        } else {
          switch (bulkReasons.TAG | 0) {
            case /* Loading */0 :
                tmp = React.createElement(CircularLoader$Catalyst.make, {});
                break;
            case /* Live */1 :
                var match$3 = form.input.fileUploadResult;
                tmp = React.createElement("form", {
                      className: "porter-form",
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          
                        })
                    }, React.createElement("div", {
                          className: "porter-form__section"
                        }, React.createElement("div", {
                              className: "porter-form__row"
                            }, React.createElement(FormSelectInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("City", (function ($$event) {
                                          return Curry._2(form.updateCity, (function (input, value) {
                                                        return {
                                                                city: value,
                                                                reason: input.reason,
                                                                fileUploadResult: input.fileUploadResult
                                                              };
                                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), cityOptions));
                                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.cityResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  select_props: {
                                    value: form.input.city,
                                    items: cityOptions,
                                    isNoneRequired: true
                                  }
                                })), React.createElement("div", {
                              className: "porter-form__row"
                            }, React.createElement(FormSelectInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("Transaction Reason", (function ($$event) {
                                          return Curry._2(form.updateReason, (function (input, value) {
                                                        return {
                                                                city: input.city,
                                                                reason: value,
                                                                fileUploadResult: input.fileUploadResult
                                                              };
                                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), reasonOptions));
                                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.reasonResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  select_props: {
                                    value: form.input.reason,
                                    items: reasonOptions,
                                    isNoneRequired: true
                                  }
                                })), React.createElement("div", {
                              className: "porter-form__row"
                            }), React.createElement("input", {
                              accept: ".csv",
                              type: "file",
                              onChange: (function ($$event) {
                                  var file = FormHelper$Catalyst.TargetEventWrapper.file($$event);
                                  return CsvFileParser$Catalyst.parseFile(file, (function (result) {
                                                return Curry._2(form.updateFileUploadResult, (function (input, value) {
                                                              return {
                                                                      city: input.city,
                                                                      reason: input.reason,
                                                                      fileUploadResult: value
                                                                    };
                                                            }), [
                                                            BulkUploadTransactionsUseCase.validate(result, file, country),
                                                            file.name
                                                          ]);
                                              }));
                                })
                            }), React.createElement("div", {
                              className: "u-background-color-disabled u-margin-top-small u-padding-small font-size-14"
                            }, "Ensure that the csv has column mentioned below", React.createElement("br", undefined), React.createElement("span", {
                                  className: "format"
                                }, "driver_msisdn | vehicle_number | amount | partner_comment | admin_comment"))), match$3 !== undefined ? BulkUploadTransactionHelper.getErrorSection(match$3[0], match$3[1], requestStatus) : null, React.createElement(ModalFooter$Catalyst.make, {
                          label: "Submit",
                          isDisabled: form.submitting,
                          cb: (function (param) {
                              return Curry._1(form.submit, undefined);
                            })
                        }));
                break;
            case /* Error */2 :
                tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: bulkReasons._0
                    });
                break;
            
          }
        }
        return React.createElement("div", {
                    className: "modalContent"
                  }, tmp);
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: georegions._0
                  });
    
  }
}

var make = BulkUploadTransactionsModalContent;

export {
  BulkUploadTransactionForm ,
  make ,
  
}
/* react Not a pure module */
